<template>
    <div>
        <hero image="https://api.ratoab.se/HeroImages?location=2"
              :dark-background="false"
              style="height: 60vh"
        />

        <about-maintenance class="mt-5"/>
    </div>
</template>

<script>
    import Hero from "../../components/Hero";
    import AboutMaintenance from "../../components/Services/AboutMaintenance";
    export default {
        name: "Maintenance",
        components: {AboutMaintenance, Hero},
        mounted () {
            window.scrollTo(0, 0)
        }
    }
</script>

<style scoped>

</style>
